import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dashboard,
  Calendar,
  plus,
  fileicon,
  SendIcon,
  GreenTickCircle,
  Recording,
  Complete,
  CrossCircled,
  bookingIcon,
  RsIcon,
  Setting,
  RightArw,
  Bookings,
  Report,
  Dashboard2Icon,
  anylitics,
  AtmCardIcon,
  Support,
  Headset,
  CrossWhite,
  BookingSidebar,
  Ruppe2,
  CompletedEvent,
  LiveEvent,
  Threeline,
  Chaticon,
  Profile1,
  plusgray,
  Notification,
  Wallet,
  InfluencerIcon,
  PersonGray,
  bed,
  Logo,
  Rightarrow,
  Downarrow2,
} from "../../assests/ExportImageIcon";
import "./sidebar.css";

const HotelSidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [openMenu, setOpenMenu] = useState(null);

  const handleClick = (name, route = null) => {
    if (route) {
      navigate(route);
    }
  };

  const handleDropdownClick = (name) => {
    if (collapsed) return;

    setOpenMenu((prev) => (prev === name ? null : name));
  };

  const isActive = (name) => {
    switch (name) {
      case "hotel-dashboard":
        return (
          location.pathname === "/hotel-dashboard" ||
          location.pathname.startsWith("/hotel-dashboard/")
        );

      case "hotel":
        return (
          location.pathname === "/hotel" ||
          location.pathname.startsWith("/hotel/")||
          location.pathname==="/hotel-detail/"||
          location.pathname.startsWith("/hotel-detail")
        );

      case "hotel-booking":
        return (
          location.pathname === "/hotel-booking" ||
          location.pathname.startsWith("/hotel-booking/")||
          location.pathname==="/hotel-booking-details"||
          location.pathname.startsWith("/hotel-booking-details/")
        );

      case "hotel-customer":
        return (
          location.pathname === "/hotel-customer" ||
          location.pathname.startsWith("/hotel-customer/")
        );

      case "hotel-reviews":
        return (
          location.pathname === "/hotel-reviews" ||
          location.pathname.startsWith("/hotel-reviews/")
        );

      case "hotel-report":
        return (
          location.pathname === "/hotel-report" ||
          location.pathname.startsWith("/hotel-report/")
        );

      case "hotel-notifications":
        return (
          location.pathname === "/hotel-notifications" ||
          location.pathname.startsWith("/hotel-notifications/")
        );

      case "hotel-profile":
        return (
          location.pathname === "/hotel-profile" ||
          location.pathname.startsWith("/hotel-profile/")||
          location.pathname==="/hotel-profile-edit"||
          location.pathname.startsWith("/hotel-profile-edit/")
        );

      case "hotel-setting":
        return (
          location.pathname === "/hotel-settings" ||
          location.pathname.startsWith("/hotel-settings/")
        );

      case "support-tickets":
        return (
          location.pathname === "/requests" ||
          location.pathname.startsWith("/requests/")
        );

      default:
        return false;
    }
  };

  const isHotelMenuActive =
    location.pathname === "/hotel" ||
    location.pathname.startsWith("/hotel/") ||
    location.pathname==="/hotel-details"||
    location.pathname.startsWith("/hotel-details/")
    location.pathname === "/create-hotel" ||
    location.pathname.startsWith("/create-hotel/");

  const isOpen = (name) => openMenu === name;

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div onClick={() => navigate("/hotel-dashboard")} className="logo">
        <img
          src={Logo}
          alt="Travel Booking"
          style={{
            maxHeight: "48px",
            maxWidth: "100%",
            objectFit: "contain",
            cursor: "pointer",
          }}
        />
      </div>

      <ul className="menu">
        <li className="menu-item">
          <div
            className={`menu-link ${isActive("hotel-dashboard") ? "active" : ""}`}
            onClick={() => handleClick("hotel-dashboard", "/hotel-dashboard")}
          >
            <img src={Dashboard} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Dashboard</span>}
          </div>
        </li>
        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${isHotelMenuActive ? "active" : ""}`}
            onClick={() => handleDropdownClick("hotel")}
            style={{ cursor: "pointer" }}
          >
            <img src={Threeline} className="menu-icon-img" alt="" />

            {!collapsed && (
              <>
                <span className="menu-text">Hotels</span>

                <span className="ms-auto">
                  {isOpen("hotel") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>

          {!collapsed && isOpen("hotel") && (
            <ul className="submenu">
              <li
                onClick={() => handleClick("hotel", "/hotel")}
                className={isActive("hotel") ? "active" : ""}
              >
                <img src={Threeline} className="menu-icon-img" alt="" />

                <span className="menu-text">Hotel List</span>
              </li>

              <li
                onClick={() => handleClick("create-Hotel", "/create-hotel")}
                className={
                  location.pathname === "/create-hotel" ||
                  location.pathname.startsWith("/create-hotel/")
                    ? "active"
                    : ""
                }
              >
                <img src={AtmCardIcon} className="menu-icon-img" alt="" />

                <span className="menu-text">Create Hotel</span>
              </li>
            </ul>
          )}
        </li>
        {/* <li className="menu-item">
          <div
            className={`menu-link ${isActive("room-management") ? "active" : ""}`}
            onClick={() => handleClick("room-management", "/room-management")}
          >
            <img src={bed} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Room Management</span>}
          </div>
        </li> */}

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("hotel-booking") ? "active" : ""}`}
            onClick={() => handleClick("hotel-booking", "/hotel-booking")}
          >
            <img src={Dashboard} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Bookings</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${
              isActive("hotel-customer") ? "active" : ""
            }`}
            onClick={() => handleClick("hotel-customer", "/hotel-customer")}
          >
            <img src={PersonGray} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Customers</span>}
          </div>
        </li>
        {/* <li className="menu-item">
          <div
            className={`menu-link ${isActive("hotel-reviews") ? "active" : ""}`}
            onClick={() => handleClick("hotel-reviews", "/hotel-reviews")}
          >
            <img src={InfluencerIcon} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Reviews</span>}
          </div>
        </li> */}

        {/* <li className="menu-item">
          <div
            className={`menu-link ${isActive("hotel-settlement") ? "active" : ""}`}
            onClick={() => handleClick("hotel-settlement", "/hotel-settlement")}
          >
            <img src={Wallet} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Settlement</span>}
          </div>
        </li> */}

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("hotel-report") ? "active" : ""}`}
            onClick={() => handleClick("hotel-report", "/hotel-report")}
          >
            <img src={Report} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Reports</span>}
          </div>
        </li>

        {/* <li className="menu-item">
          <div
            className={`menu-link ${isActive("hotel-notifications") ? "active" : ""}`}
            onClick={() =>
              handleClick("hotel-notifications", "/hotel-notifications")
            }
          >
            <img src={Notification} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Notifications </span>}
          </div>
        </li> */}

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("hotel-profile") ? "active" : ""}`}
            onClick={() => handleClick("hotel-profile", "/hotel-profile")}
          >
            <img src={Profile1} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Profile</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("hotel-setting") ? "active" : ""}`}
            onClick={() => handleClick("hotel-setting", "/hotel-settings")}
          >
            <img src={Setting} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Settings</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("support-tickets") ? "active" : ""}`}
            onClick={() => handleClick("support-tickets", "/requests")}
          >
            <img src={Headset} className="menu-icon-img" alt="" />
            {!collapsed && <span className="menu-text">Support & Ticket</span>}
          </div>
        </li>
      </ul>
    </div>
  );
};

export default HotelSidebar;
